import React from 'react';
import { motion } from 'framer-motion';
import freshstartImage from './Images/ielts2.jpg';
import { Container, Typography, Box, Card, CardContent, CardMedia, Button, List, ListItem, ListItemText, Grid } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import Nav from '../../../Nav';

const IELTS = () => {
  return (
    <>

      <Nav />
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }}>
        <Box sx={{ backgroundColor: '#f8fafc', py: 5, fontFamily: 'Arial, sans-serif' }}>
          <Box sx={{ backgroundImage: `url(${freshstartImage})`, backgroundSize: 'cover', py: 10, textAlign: 'center', color: '#fff' }}>
            <Container maxWidth="lg">
              <Typography variant="h1" align="center" gutterBottom sx={{ fontWeight: 'bold', fontFamily: 'Arial, sans-serif', color: '#fff' }}>
                IELTS & TOEIC
              </Typography>
            </Container>
          </Box>

          <Container maxWidth="lg" sx={{ backgroundColor: '#ffffff', p: 5, borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', mt: -8 }}>
            <Grid container spacing={5} alignItems="flex-start" mb={10}>
              <Grid item xs={12} lg={6}>
                <Typography variant="h4" gutterBottom sx={{ fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#172b4d' }}>
                  Course will be there soon!
                </Typography>
              </Grid>
              <Grid item xs={12} lg={6}>
                <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ duration: 0.5, delay: 0.2 }}>
                  <CardMedia
                    component="img"
                    image={freshstartImage}
                    alt="Fresh Start"
                    sx={{ borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}
                  />
                </motion.div>
              </Grid>
            </Grid>

            <Box textAlign="center" mb={10}>
              <Button variant="contained" color="primary" size="large" sx={{ borderRadius: 5, px: 5, py: 2 }}>
                Join Now
              </Button>
            </Box>
          </Container>
        </Box>
      </motion.div>
    </>
  );
};

export default IELTS;
